// extracted by mini-css-extract-plugin
export var arrows = "_1r-6";
export var decrementer = "_1r-a";
export var disabled = "_1r-4";
export var error = "_1r-1";
export var hiddenText = "_1r-b";
export var incrementer = "_1r-9";
export var input = "_1r-8";
export var inputWrapper = "_1r-0";
export var leadingIcon = "_1r-c";
export var readonly = "_1r-3";
export var regular = "_1r-7";
export var small = "_1r-5";
export var warning = "_1r-2";